import auth from '@client/components/auth';
import { NavMenuItemProps } from '@design-system/components/menu/NavMenuItem';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export type Role = 'admin' | 'moderator' | 'contentEditor' | 'unknown';

export const getRole = (): Role => {
  if (auth.isAdministrator()) return 'admin';
  if (auth.isModerator()) return 'moderator';
  if (auth.isContentEditor()) return 'contentEditor';
  return 'unknown';
};

export const toPascalCase = (t: string): string =>
  t
    ? t
        .split(/[\s\-_]+/)
        .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
        .join('')
    : '';

export const toTestId = (caption: string): string => {
  return 'MainMenuItem' + toPascalCase(caption);
};

export const externalLink = (
  caption: string,
  to: string,
  icon: IconProp,
  delta?: Partial<NavMenuItemProps>,
): NavMenuItemProps => ({
  caption,
  to,
  externalLink: true,
  icon,
  testId: delta?.testId || toTestId(caption),
  ...delta,
});
